var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(12 2) scale(0.8)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m11.2 10.5c0.2 9.5 1.8 20 6.8 20s6.6-10.5 6.8-20z",
  fill: "#dfe6ec"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 18,
  cy: 10.3,
  rx: 7,
  ry: 2.2,
  fill: "#8f9ba3"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 18,
  cy: 10.3,
  rx: 5.2,
  ry: 1.4,
  fill: "#5c6870"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m11.2 10.5c0.2 9.5 1.8 20 6.8 20s6.6-10.5 6.8-20z",
  fill: "#eef1f5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m12.6 14 8.8 8.6",
  fill: "none",
  stroke: "#c3ccd2",
  strokeWidth: 0.8
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m12.4 19 6.6 7.6",
  fill: "none",
  stroke: "#c3ccd2",
  strokeWidth: 0.8
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m23.4 14-8.8 8.6",
  fill: "none",
  stroke: "#c3ccd2",
  strokeWidth: 0.8
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m23.6 19-6.6 7.6",
  fill: "none",
  stroke: "#c3ccd2",
  strokeWidth: 0.8
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 18,
  cy: 10.3,
  rx: 7,
  ry: 2.2,
  fill: "#8f9ba3"
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 18,
  cy: 10.3,
  rx: 5.2,
  ry: 1.4,
  fill: "#5c6870"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m18 32.5c0 0 1 1.7 1 2.5 0 0.6-0.45 1-1 1s-1-0.4-1-1c0-0.8 1-2.5 1-2.5z",
  fill: "#9fd8ef"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m14.8 36.2c0 0 0.85 1.5 0.85 2.2 0 0.55-0.4 0.9-0.85 0.9s-0.85-0.35-0.85-0.9c0-0.7 0.85-2.2 0.85-2.2z",
  fill: "#9fd8ef"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m21.2 36.2c0 0 0.85 1.5 0.85 2.2 0 0.55-0.4 0.9-0.85 0.9s-0.85-0.35-0.85-0.9c0-0.7 0.85-2.2 0.85-2.2z",
  fill: "#9fd8ef"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 37.5,
  cy: 8.5,
  r: 6,
  fill: "#23967f"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m40.8 8.5a3.3 3.3 0 1 1-3.3-3.3",
  fill: "none",
  stroke: "#ffffff",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m37.3 3.5 3.2 1.7-3.2 1.7z",
  fill: "#ffffff"
});

function SvgFilterSocks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSocks);
export default __webpack_public_path__ + "static/media/filter-socks.331bfc9cadd7a351e486c292d9596a7a.svg";
export { ForwardRef as ReactComponent };